import { IconButton, Tooltip } from '@mui/material';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import { useTranslation } from 'react-i18next';
import { useColorMode } from '../../theme/ColorModeContext';

type Props = {
  size?: 'small' | 'medium' | 'large';
  edge?: 'start' | 'end' | false;
};

export function ThemeToggle({ size = 'medium', edge = false }: Props) {
  const { mode, toggle } = useColorMode();
  const { t } = useTranslation();
  const isDark = mode === 'dark';
  const label = isDark ? t('theme.switchToLight') : t('theme.switchToDark');

  return (
    <Tooltip title={label}>
      <IconButton
        onClick={toggle}
        size={size}
        edge={edge}
        aria-label={label}
        sx={{
          color: 'text.primary',
          transition: 'transform 200ms ease, background-color 200ms ease',
          '&:hover': {
            backgroundColor: (theme) => theme.palette.action.hover,
            transform: 'rotate(15deg)',
          },
        }}
      >
        {isDark ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
      </IconButton>
    </Tooltip>
  );
}
